// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TBFhJ","colBig":"styles_colBig__trEPb","colSmall":"styles_colSmall__2pZm-","shopifyNameWrapper":"styles_shopifyNameWrapper__YnCrV"};